import React from 'react';
import { Dialog, Slide } from "@material-ui/core";
import ImageIcon from '@material-ui/icons/Image';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    columnLink: {
		alignItems: 'center',
		'&:hover': {
            cursor: 'pointer'
        },
    },
    closeButton: {
        position: "absolute",
        top: 10,
        right: 10,
        borderRadius: 100,
        backgroundColor: "#00000060",
        display: "grid",
        justifyContent: "center",
        padding: 4,
        '&:hover': {
            cursor: "pointer"
        }
    },
    paperScrollPaper: {
        overflow: "visible",
    }
});

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function ImageDialog(props) {
    const classes = useStyles();
    const { record, source } = props;

    const [dialogVisible, setDialogVisible] = React.useState(false);

    const openDialog = state => {
        setDialogVisible(true);
    };
    
    const closeDialog = () => {
        setDialogVisible(false);
    };

    if(record == null || record[source] == null || record[source] === "")
        return null;

    return (
        <div style={{ textAlign: "center" }}>
            <div className={classes.columnLink} onClick={openDialog}>
                <ImageIcon style={{ fontSize: 20 }} />
            </div>

            <Dialog open={dialogVisible} onClose={closeDialog} TransitionComponent={Transition} scroll="body" classes={{ paperScrollPaper: classes.paperScrollPaper }}>
                <div style={{ overflowY: "auto" }}>
                    <img src={record[source]} style={{ width: "100%" }} alt={source} />
                </div>
                <div className={classes.closeButton} onClick={closeDialog}>
                    <CloseIcon style={{ fontSize: 24, color: "#fff" }} />
                </div>
            </Dialog>
        </div>
    );
}